// @flow
import React from 'react';

import { NAVIGATION_TAB } from 'Client/cms/toolkit/constants';
import { Line } from 'Components/frameworks/line/Line.jsx';

export const navigationTabDescriptor = {
  name: NAVIGATION_TAB,
  component: (props: *) => <Line props={props} />,
};
